import React from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';

import { Breadcrumb, NavLinkButton } from '@shared/components/bootstrap';

import { PageHeader } from '@admin/components/helpers/page_header';
import { Panel } from '@admin/components/helpers/panel';
import { List as ContentPanel } from '@admin/components/landing/location/content/list';
import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { LandingLocationNeighborhoodQuery, useLandingLocationNeighborhoodQuery } from '@admin/schema';

const Content: React.FC<{
  neighborhood: LandingLocationNeighborhoodQuery['neighborhood'];
}> = ({ neighborhood }) => (
  <>
    <Panel>
      <Panel.Body>
        <div>
          City: <strong>{neighborhood.city.name}</strong>
        </div>
        <div>
          Slug: <strong>{neighborhood.slug}</strong>
        </div>
        <div>
          Name: <strong>{neighborhood.name}</strong>
        </div>
        <div>
          Latitude: <strong>{neighborhood.latitude}</strong>
        </div>
        <div>
          Longitude: <strong>{neighborhood.longitude}</strong>
        </div>
      </Panel.Body>
      <Panel.Footer align="right">
        <NavLinkButton kind="primary" to={`/landing/location/neighborhoods/${neighborhood.id}/edit`}>
          Edit
        </NavLinkButton>
      </Panel.Footer>
    </Panel>
    <ContentPanel location={neighborhood} />
  </>
);

export const Details: React.FC = () => {
  useTitle('Landing - Location - Neighborhoods - Details');
  const { id } = useParams<{ id: string }>();
  const { data } = useLandingLocationNeighborhoodQuery({
    client,
    fetchPolicy: 'cache-and-network',
    variables: { id },
  });
  const neighborhood = data?.neighborhood;

  return (
    <>
      <PageHeader>
        <Breadcrumb>
          <Breadcrumb.Item>Landing</Breadcrumb.Item>
          <Breadcrumb.Item>Location</Breadcrumb.Item>
          <Breadcrumb.Item>
            <NavLink to="/landing/location/neighborhoods">Neighborhoods</NavLink>
          </Breadcrumb.Item>
          {id && <Breadcrumb.Item active>{neighborhood?.name ?? '-'}</Breadcrumb.Item>}
        </Breadcrumb>
      </PageHeader>
      {neighborhood ? <Content neighborhood={neighborhood} /> : <Spinner />}
    </>
  );
};
